import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {LogoHeader} from '@mintdata-wsp/wsp/ui/pages/general/LogoHeader';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {Component} from 'react';
import {RouteComponentProps} from 'react-router';

const styles = require('./NewPasswordPage.less');
const cx = classnames.bind(styles);

@observer
export class NewPasswordPage extends Component<RouteComponentProps<any>, any>
{
    componentDidMount()
    {
        controllers.ui.dialogs.showDialog(Dialogs.NewPasswordForm, true, this.props);
        controllers.ui.anyPage.disablePageLoader();

        commonControllers.analytics.main.initAllVendors();
        controllers.analytics.main.trackEvent(AnalyticsEventActions.WSP_PAGE_LOADED);
    }

    render()
    {
        return (
            <div className={cx('changePasswordPage')}>
                <LogoHeader />
                {controllers.ui.dialogs.renderAllPublic()}
            </div>
        );
    }
}
